export default __webpack_public_path__ + "f932f2b56fbd48cd9e14a21f5c15d1b5.png";